
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import IconOeamtcClose from '@/components/icons/icon-oeamtc-close.svg';

@Component({
  name: 'ArchivedTripSection',
  components: {
  }
})
export default class ArchivedTripSection extends Vue {

}
